
import { useRef } from "react";

interface MediaPlanningContentProps {
  label: string;
  title: string;
  description: string;
  ctaText: string;
  ctaLink: string;
}

const MediaPlanningContent = ({ 
  label,
  title,
  description,
  ctaText,
  ctaLink
}: MediaPlanningContentProps) => {
  return (
    <div className="flex flex-col justify-between h-full space-y-4 md:space-y-6 order-1 md:order-1">
      <div className="space-y-4 md:space-y-6">
        <div className="flex flex-col items-start gap-1 md:gap-4">
          <div className="flex items-center gap-4">
            <img 
              src="/lovable-uploads/0da7aa55-56eb-4554-b461-af3d6b5ed261.png" 
              alt="Calendar icon" 
              className="w-12 h-10 md:w-16 md:h-14"
            />
            <p className="text-sm font-medium tracking-wider text-secondary uppercase">{label}</p>
          </div>
          <h2 className="text-[2.25rem] leading-[1.1] md:text-6xl font-medium tracking-tight text-primary font-charter">
            {title}
          </h2>
        </div>
        <p className="text-sm md:text-xl text-secondary">
          {description}
        </p>
      </div>
      <div className="flex justify-start">
        <a 
          href={ctaLink}
          className="px-6 py-2 md:py-3 text-sm md:text-base bg-white md:bg-black text-black md:text-white border md:border-0 border-black rounded-full hover:bg-[#27B5FC] hover:border-transparent hover:text-black transition-colors duration-300"
        >
          {ctaText}
        </a>
      </div>
    </div>
  );
};

export default MediaPlanningContent;
